<template>
  <div class="help__item">
    <div class="help__title">
      <h3>{{ help.title }}</h3>
    </div>

    <div
      class="help__definition"
      v-if="help.definition">
      <div v-html="help.definition" />
    </div>

    <div
      class="help__content"
      v-if="help.content">
      <div v-html="help.content" />
    </div>

    <div
      class="help__note"
      v-if="help.note">
      <div v-html="help.note" />
    </div>

    <div class="help__video-container">
      <div
        v-for="(media, index) in videos"
        :key="index"
        class="help__media">
        <h5 v-if="media.title">
          {{ media.title }}
        </h5>
        <div
          class="help__video">
          <YouTubePlayer
            :video-id="getIdFromURL(media.videoUrl)"
            player-width="100%"
            player-height="100%" />
        </div>
      </div>
    </div>

    <div class="help__image-container">
      <div
        v-for="(media, index) in images"
        :key="index"
        class="help__img">
        <h5 v-if="media.title">
          {{ media.title }}
        </h5>
        <v-icon
          v-if="isOfficeInitialized"
          :title="$t('components.helpItem.openInNewTab', 'Open in new tab')"
          class="external-link-button"
          @click="openNewTab"
          small>
          fas fa-external-link-alt
        </v-icon>
        <fullscreen
          ref="imgFullscreen"
          @click.native="toggleFullScreenImg(index)">
          <img
            :class="!isOfficeInitialized ? 'clickable' : ''"
            :src="media.imageUrl"
            v-img-fallback>
        </fullscreen>
      </div>
    </div>
  </div>
</template>

<script>
import { YouTubePlayer, getIdFromURL } from 'vue-youtube-embed'
import { mapState } from 'vuex'

export default {
  props: {
    help: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    ...mapState('office', {
      isOfficeInitialized: state => state.initialized
    }),
    resolvedRoute () {
      return this.$router && this.$route && this.$router.resolve(this.$route.fullPath)
    },
    videos () {
      return this.help && this.help.medias.filter(media => media.videoUrl)
    },
    images () {
      return this.help && this.help.medias.filter(media => media.imageUrl)
    },
    origin () {
      return window.location.origin
    },
    href () {
      return this.resolvedRoute && [this.origin, this.resolvedRoute.href].join('/')
    }
  },
  methods: {
    getIdFromURL (videoUrl) {
      return videoUrl && getIdFromURL(videoUrl)
    },
    toggleFullScreenImg (index) {
      if (!this.isOfficeInitialized) {
        const fullscreen = this.$refs.imgFullscreen[index]
        if (fullscreen) {
          fullscreen.toggle()
        }
      }
    },
    openNewTab () {
      if (this.isOfficeInitialized) {
        window.open(this.href, '_blank')
      }
    }
  },
  components: {
    YouTubePlayer
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @import "~common-assets/scss/we";
    $font-size : 15px;
    .help {
        &__item {
            border-bottom: 1px solid #cecece;
            margin-bottom: 15px;
            font-size: $font-size;
        }
        &__title {
            margin-bottom: 15px;
        }
        &__definition {
        }
        &__content {
        }
        &__note {
            background: rgba(224, 224, 224, 0.59);
            padding: 15px;
            margin-bottom: 9px;
        }

        &__video-container {
        }
        &__video {
            height: 400px;
            margin-top: 5px;
            margin-bottom: 17px;
            /deep/ {
                > div {
                    @extend .full-size;
                }
            }
        }

        &__image-container {
            position: relative;
            white-space: nowrap;
            display: inline-block;
        }
        &__img {
            float: left;
            margin: 10px 50px 10px 0;
            position: relative;
            min-width: 200px;
            max-width: 500px;
            img {
                margin-top: 5px;
                @extend .full-size;
                object-fit: contain;
                &.clickable {
                  cursor: pointer;
                }
            }

            .external-link-button {
                opacity: 0;
                position: absolute;
                top: -17px;
                right: 25px;
            }

            &:hover {
                .external-link-button {
                    opacity: 1;
                }
            }
        }
    }
</style>
